export const cacheKeys = {
  disablePersonalization: 'disable_personalization',
  chatSession: 'chat_session',
  messageLimitAuthDialog: 'message_limit_auth_dialog',
  messageText: 'message_text',
  openSubscriptionModel: 'open_subscription_model',
  downloadApp: 'download_app_cookie_name',
  consultationMedium: 'consultation_medium',
  sinaAppPopupClosed: 'sina_app_popup_closed',
  sinaProAnnouncement: 'sina_pro_announcement',
} as const


export type CacheKeys = typeof cacheKeys[keyof typeof cacheKeys]
